module.exports = __webpack_public_path__ + "static/media/supabase.0b33d3ec.svg";